import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.REACT_APP_API_ROOT+ '/api/brand/';

class BrandService {
  fetch() {
    return axios.post(API_URL + 'fetch',{}, { headers: authHeader(true) });
  }
  clear() {
    return axios.post(API_URL + 'clear',{}, { headers: authHeader(true) });
  }
}

export default new BrandService();
